module.exports = __webpack_public_path__ + "static/infraspace_logo-96bd517f4962e02579d82a251590ebd1.png";